export class TrainingStage {
    constructor(id, label, isFinal = false, isError = false, errorText) {
        this.id = id;
        this.label = label;
        this.isFinal = isFinal;
        this.isError = isError;
        this.errorText = errorText;
    }
}
